<template>
  <div>
    <el-table
      :load="loading"
      :data="list"
      :border="true"
      :max-height="maxHeight"
      size="small"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
    >
      <el-table-column prop="recordTime" label="操作时间" />
      <el-table-column prop="operator" label="操作方">
        <template slot-scope="scope">
          {{ scope.row.operator || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="operatorName" label="操作人">
        <template slot-scope="scope">
          {{ scope.row.operatorName || scope.row.operateUserName }}
        </template>
      </el-table-column>
      <el-table-column prop="operateTypeMsg" label="操作类型">
        <template slot-scope="scope">
          {{ scope.row.operateTypeMsg || scope.row.operateType }}
        </template>
      </el-table-column>
      <el-table-column prop="newRecord" label="操作内容">
        <template slot-scope="scope">
          <template v-if="scope.row.operateType == 20005">
            <div
              class="image-view"
              v-for="(item, index) in (scope.row.newRecord || '').split(',')"
              :key="`${item}_${index}`"
            >
              <i class="el-icon-zoom-in icon"></i>
              <el-image :src="item" :preview-src-list="(scope.row.newRecord || '').split(',')" />
            </div>
          </template>
          <span v-else style="white-space: pre-wrap" v-html="scope.row.newRecord || '无'"></span>
        </template>
      </el-table-column>
      <el-table-column prop="oldRecord" label="原内容">
        <template slot-scope="scope">
          <span style="white-space: pre-wrap" v-html="scope.row.oldRecord || '无'"></span>
        </template>
      </el-table-column>
      <template> </template>
    </el-table>
  </div>
</template>

<script>
  export default {
    name: 'LogList',
    props: {
      list: {
        type: Array,
        default() {
          return []
        }
      },
      maxHeight: {
        type: [Number || String],
        default: () => '400px'
      }
    },
    data() {
      return {}
    },
    watch: {
      maxHeight(val) {
        if (val) {
          this.$nextTick(() => {
            this.$forceUpdate()
          })
        }
      }
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>
<style scoped lang="scss">
  .image-view {
    display: inline-block;
    width: 25px;
    height: 25px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    text-align: center;
    margin-left: 5px;
    &:hover {
      cursor: pointer;
      .icon,
      &:after {
        display: block;
        pointer-events: none;
      }
    }
    .icon {
      position: absolute;
      width: 15px;
      height: 15px;
      z-index: 2;
      left: 50%;
      top: 50%;
      font-size: 18px;
      color: #fff;
      transform: translateX(-50%) translateY(-50%);
      display: none;
    }
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1;
      display: none;
    }
  }
</style>
